module.exports = __webpack_public_path__ + "static/media/badge_star.7e0517bd.svg";